import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
})

const { Types, Creators } = createActions({
  syncPendingRequests: null,
  unSyncPendingRequests: null,

  setPendingRequests: ['data'],
  setLoading: ['val'],
})

export const setPendingRequestsReducer = (state, { data }) => state
  .set('data', data)
  .set('loading', false)

export const syncPendingRequestsReducer = state => state.set('loading', true)

export const unSyncPendingRequestsReducer = state=> state.set('loading', false)

export const merchantCloseRequestReducer = createReducer(INITIAL_STATE, {
  [Types.SYNC_PENDING_REQUESTS]: syncPendingRequestsReducer,
  [Types.UN_SYNC_PENDING_REQUESTS]: unSyncPendingRequestsReducer,

  [Types.SET_PENDING_REQUESTS]: setPendingRequestsReducer,
})

export const MerchantCloseRequestTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/merchantCloseRequestReducer.js